<a *ngIf="isFiltersSelected" (click)="resetFilters()" class="reset-filters">
  <mat-icon>backspace</mat-icon>&nbsp;<span translate="inbox/filters/reset"></span>
</a>

<app-account-selector
  [initialQueueId]="taskListConfiguration.queueId"
  (sitesChange)="sitesChange($event)"
  class="select"></app-account-selector>

<ng-container *ngFor="let filter of tplFilters; index as index">
  <app-select
    [control]="filter.control"
    [items]="filter.choices"
    [label]="filter.name"
    [matTooltip]="filter.tooltip"
    [matTooltipDisabled]="filter.control.enabled"
    [panelClass]="'panel-content-width'"
    [formFieldClass]="'no-vertical-padding'"
    class="select">
  </app-select>
</ng-container>

<app-task-list-sort
  [taskListConfiguration]="taskListConfiguration"
  [taskListMode]="taskListMode"
  class="select"></app-task-list-sort>
